// Previous / next under a paged list, with the page number between; hidden when there is only
// one page.
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Button } from "rizzui";

import { useT } from "../../../i18n";

export function Pager({ page, hasNext, onPage }: { page: number; hasNext: boolean; onPage: (page: number) => void }) {
  const t = useT().tasks.create.workflow;
  if (page === 0 && !hasNext) return null;
  return (
    <nav className="flex items-center justify-between gap-3" aria-label={t.pages}>
      <Button size="sm" variant="outline" className="gap-1" disabled={page === 0} onClick={() => onPage(page - 1)}>
        <CaretLeft className="h-3.5 w-3.5" /> {t.previous}
      </Button>
      <span className="text-sm text-gray-500" aria-live="polite">
        {t.page(page + 1)}
      </span>
      <Button size="sm" variant="outline" className="gap-1" disabled={!hasNext} onClick={() => onPage(page + 1)}>
        {t.next} <CaretRight className="h-3.5 w-3.5" />
      </Button>
    </nav>
  );
}
